import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchShippingCostTable } from 'src/api/shipping-cost-table';
import {
    FETCH_SHIPPING_COST_TABLE,
    requestShippingCostTable,
    requestShippingCostTableFailure,
    requestShippingCostTableSuccess,
} from 'src/store/shipping-cost-table/actions';

function* fetchShippingCostTableSaga(action: AnyAction): SagaIterator {
    yield put(requestShippingCostTable());

    const { error, response } = yield call(fetchShippingCostTable);

    if (error) yield put(requestShippingCostTableFailure(error));
    else yield put(requestShippingCostTableSuccess(response));
}

export function* generateFetchShippingCostTableWatcher() {
    yield takeLatest(FETCH_SHIPPING_COST_TABLE, fetchShippingCostTableSaga);
}
